import React, {useState} from 'react';
import HeaderItem from "./HeaderItem.jsx";
import {useLaravelReactI18n} from "laravel-react-i18n";
import {Form} from "react-bootstrap";

export default function HeaderRow(props) {
  const { t,getLocales } = useLaravelReactI18n();
  const {hiddenCols, actions, actionsDisplay} = props;

  const handleCheckboxChange = (event) => {
    props.onSelectAllChange(event.target.checked);
  };

  return (
    <tr>
      {props.showCheckbox && (
        <th style={{ textAlign: 'center' }}>
          <Form.Check
            aria-label="option 1"
            checked={props.selectAll}
            onChange={handleCheckboxChange}
          />
        </th>
      )}

      {props.cols.map((col) => {
        if (col.hidden) return false;
        if (hiddenCols && hiddenCols.includes(col.id)) return false;

        // Zugriff auf das neue "enums"-Objekt, um den Wert für die Spalte zu holen
        const enumValue = props.enums?.[col.id] || null;

        return (
          <HeaderItem
            key={col.id}
            id={col.id}
            disabled={props.disabled}
            colDefinition={col}
            onSort={props.onSort}
            onEnumSelect={props.onEnumSelect}
            className="px-4 py-2 w-20"
            sortable={props.sortCol === col.id}
            direction={props.direction}
            enumSelected={enumValue}
          >
            {t(col.title)}
          </HeaderItem>
        );
      })}

      {actionsDisplay === 'column' && actions && (
        <th className="actions-cell" style={{ textAlign: 'center', whiteSpace: 'nowrap' }}>
          {t('actions')}
        </th>
      )}
    </tr>
  );
}

